import axios from "./axiosInstance";
import {
  StudentExitApiResponse,
  StudentExitsApiResponse,
  StudentExitCreatePayload,
  StudentExitUpdatePayload,
  StudentExitQueryParams
} from "../types/studentExitTypes";

export const getStudentExits = async (params: StudentExitQueryParams): Promise<StudentExitsApiResponse> => {
  const response = await axios.get<StudentExitsApiResponse>("/student-exits", { params });
  return response.data;
};

export const getStudentExitById = async (id: string): Promise<StudentExitApiResponse> => {
  const response = await axios.get<StudentExitApiResponse>(`/student-exits/${id}`);
  return response.data;
};

export const createStudentExit = async (payload: StudentExitCreatePayload): Promise<StudentExitApiResponse> => {
  const response = await axios.post<StudentExitApiResponse>("/student-exits", payload);
  return response.data;
};

export const updateStudentExit = async (id: string, payload: StudentExitUpdatePayload): Promise<StudentExitApiResponse> => {
  const response = await axios.put<StudentExitApiResponse>(`/student-exits/${id}`, payload);
  return response.data;
};

export const approveStudentExit = async (id: string, notes?: string): Promise<StudentExitApiResponse> => {
  const response = await axios.patch<StudentExitApiResponse>(`/student-exits/${id}/approve`, { notes });
  return response.data;
};

export const rejectStudentExit = async (id: string, notes?: string): Promise<StudentExitApiResponse> => {
  const response = await axios.patch<StudentExitApiResponse>(`/student-exits/${id}/reject`, { notes });
  return response.data;
};

export const completeStudentExit = async (id: string): Promise<StudentExitApiResponse> => {
  const response = await axios.patch<StudentExitApiResponse>(`/student-exits/${id}/complete`);
  return response.data;
};

export const deleteStudentExit = async (id: string): Promise<StudentExitApiResponse> => {
  const response = await axios.delete<StudentExitApiResponse>(`/student-exits/${id}`);
  return response.data;
};

export const getDailySchedulePeriods = async (id: string): Promise<any> => {
  const response = await axios.get<any>(`/student-exits/${id}/daily-schedule-periods`);
  return response.data;
};

